import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { BrandPulse } from '@/components/brand/BrandMark';
import { FaiscaCredito } from '@/components/brand/FaiscaCredito';

export function NotFoundPage() {
  return (
    <Stack
      spacing={2}
      sx={{
        minHeight: '70dvh',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      <BrandPulse size={72} />
      <Typography variant="h2" component="h1">
        404
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 360 }}>
        Essa faísca não acendeu: a página não existe. Confira o endereço ou volte para o início.
      </Typography>
      <Button component={RouterLink} to="/" variant="contained" size="large">
        Voltar para o início
      </Button>
      <Box
        sx={{
          mt: 4,
          pt: 3,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <FaiscaCredito />
      </Box>
    </Stack>
  );
}
